import * as React from "react";
import ReportesForm from "../components/ReportesForm";

function MenuAppBar() {
  return <ReportesForm />;
}

export default MenuAppBar;
